import React from 'react';
import ProductTagManager from '../Common/ProductTagManager';
import { useSelector } from 'react-redux';
import { RootState } from '../../support/store';
import { useParams } from 'react-router-dom';
import { useFetchCustomer } from '../../hooks/customer-hooks';
import { useFetchOpportunity } from '../../hooks/opportunity-hooks';

interface OppProductsProps {
  competitive?: boolean;
}

const OppProducts: React.FC<OppProductsProps> = ({
  competitive = false
}) => {
  const { id: opportunityId } = useParams();
  const { data: opportunity } = useFetchOpportunity(opportunityId);
  const { data: customer } = useFetchCustomer(opportunity?.AccountId, { enabled: !!opportunity });

  const allProducts = useSelector((state: RootState) => state.products.items);
  let title = 'Opportunity Solutions';
  if (competitive) {
    title = 'Competitive Products';
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <ProductTagManager
        title={title}
        isCisco={!competitive}
        editable={true}
        productKind={'opportunity'}
        opportunityID={opportunityId}
        customerId={customer?.Id ?? customer?.id}
      />
    </div>
  );
};

export default OppProducts;